import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState('');
  const [status, setStatus] = useState('Completing sign in...');

  useEffect(() => {
    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          setError('No session ID found');
          setTimeout(() => navigate('/login'), 2000);
          return;
        }

        // Call backend to process session
        setStatus('Verifying your account...');
        const response = await axios.post(`${API}/auth/session`, {
          session_id: sessionId
        }, {
          withCredentials: true
        });

        if (response.data.user) {
          // Set flag to skip delay in ProtectedRoute
          sessionStorage.setItem('just_authenticated', 'true');
          
          // Check if user has already selected a role
          setStatus('Checking your profile...');
          const savedRole = localStorage.getItem('medplexity_user_role');
          
          // Also check backend for role (in case localStorage was cleared)
          try {
            const profileResponse = await axios.get(`${API}/user/profile`, {
              withCredentials: true
            });
            
            const hasRole = profileResponse.data.role || savedRole;
            
            if (hasRole) {
              // User has role - save to localStorage if not present
              if (profileResponse.data.role && !savedRole) {
                localStorage.setItem('medplexity_user_role', profileResponse.data.role);
                const modeMapping = {
                  'doctor': 'clinic',
                  'patient': 'patient',
                  'researcher': 'researcher',
                  'clinic': 'clinic'
                };
                localStorage.setItem('medplexity_mode', modeMapping[profileResponse.data.role] || 'patient');
              }
              
              // Go directly to unified dashboard
              navigate('/dashboard', { replace: true });
            } else {
              // User needs to select a role - FIRST TIME USER
              setStatus('Setting up your account...');
              navigate('/role-selection', { 
                state: { user: response.data.user },
                replace: true 
              });
            }
          } catch (profileErr) {
            // If profile check fails, go directly to dashboard
            console.log('Profile check failed, redirecting to dashboard:', profileErr);
            navigate('/dashboard', { replace: true });
          }
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        setError('Authentication failed. Please try again.');
        setTimeout(() => navigate('/login'), 2000);
      }
    };

    processAuth();
  }, []); // Empty deps - run once

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #e0f2f7 0%, #fce4ec 100%)'
    }}>
      <div style={{ textAlign: 'center' }}>
        {error ? (
          <>
            <div style={{ fontSize: '1.5rem', color: '#d32f2f', marginBottom: '1rem' }}>
              ❌ {error}
            </div>
            <p style={{ color: '#78909c' }}>Redirecting to login...</p>
          </>
        ) : (
          <>
            <div className="loading-spinner" style={{ margin: '0 auto 1.5rem' }}></div>
            <h2 style={{ color: '#0277bd', fontSize: '1.5rem', marginBottom: '0.5rem' }}>
              {status}
            </h2>
            <p style={{ color: '#78909c' }}>Please wait</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
